import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ds from '../../../Services/DataServices'
import IntlMessages from '../../../util/IntlMessages'
import StockControl from '../../../assets/images/stock-control.png'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router'
import {
  Card,
  Table,
  Button,
  Input,
  Row,
  Col,
  message,
  Form,
  Select,
  Spin,
  DatePicker,
  Space,
  Collapse,
  Tag
} from 'antd'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { STOCK_LIST } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { stringify } from 'querystring'
import {
  StringIsNullOrEmpty,
  isEmptyObject,
  checkRightspermissions,
  getDecryptID,
  notAllowMsgCheck,
  formatDigits,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import moment from 'moment'
import { StockOrderTypesEnum } from '../../../constants/StockOrderTypesEnum'
import { StockOrderStatusTypesEnum } from '../../../constants/StockOrderStatusTypesEnum'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const StockControlList = () => {
  const Panel = Collapse.Panel
  const [form] = Form.useForm()
  const history = useHistory()
  const dispatch = useDispatch()

  //#region useSelector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )

  //#endregion useSelector

  //#region useState

  const [mappedFilteredData, setmappedFilteredData] = useState([])
  const [mappedStatusData, setmappedStatusData] = useState([])
  const [Loader, setLoader] = useState(true)
  const [getExpand, setExpand] = useState(false)
  const [getIsLoading, setIsLoading] = useState(true)
  const [supplierData, setSupplierData] = useState([])
  const [getCurrData, setCurrData] = useState({})
  const [getShortCurr, setShortCurr] = useState('EUR')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getPagination, setPagination] = React.useState({
    current: 1,
    pageSize: 10
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  //#endregion useState

  //#region useEffect

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(STOCK_LIST))
      if (!verifyPkgFeature(PkgFeatures.InventoryManagement)) {
        setIsFeatureAllowed(false)
      }
      getSuppliersService()
      getStockOrderStatusTypes()
      let body = { CurrentPageNo: getPagination.current }
      getStockOrderListingData(body, PkgFeatures.InventoryManagement)
    }

    return () => (mounted = false)
  }, [])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }

  //#endregion useEffect

  //#region Api Services
  async function getStockOrderListingData (body, featureID) {
    await ds
      .getStockOrdersListing(body, BEHAVIOUR_TYPE.GET, featureID)
      .then(res => {
        setLoader(false)
        setIsLoading(false)
        if (res.data.data) {
          if (res.data.data.length > 0) {
            let mapped = res.data.data.map((data, i) => {
              return {
                key: i,
                number: !StringIsNullOrEmpty(data.orderNumber)
                  ? data.orderNumber
                  : !StringIsNullOrEmpty(data.referenceName)
                  ? data.referenceName
                  : data.returnNumber,
                from: !StringIsNullOrEmpty(data.deliverFrom)
                  ? data.deliverFrom
                  : data.supplierName,
                to:
                  parseInt(getDecryptID(data.stockOrderStatusTypeID)) ==
                    StockOrderStatusTypesEnum.OpenReturns ||
                  parseInt(getDecryptID(data.stockOrderStatusTypeID)) ==
                    StockOrderStatusTypesEnum.SentReturns
                    ? data.supplierName
                    : data.deliverTo,
                items: data.items,
                reference: data.reference,
                totalCost: data.totalCost,
                created: data.created,
                StockOrderTypeID: parseInt(getDecryptID(data.stockOrderTypeID)),
                status: data.status,
                StockOrderType: data.listingStockTypeName,
                StockOrderID: data.stockOrderID,
                SupplierInvoiceNumber: data.supplierInvoiceNumber,
                DeliveryDate: data.deliveryDate,
                StockOrderStatusTypeID: parseInt(
                  getDecryptID(data.stockOrderStatusTypeID)
                )
              }
            })
            //let filteredMap = mapped.filter((a) => a.status == "Open Orders");
            setmappedFilteredData(mapped)
            let paginationObj = {
              current: body.CurrentPageNo,
              pageSize: getPagination.pageSize,
              total:
                res.data.data.length > 0 ? res.data.data[0].totalRecords : 0
            }
            setPagination(paginationObj)
          } else {
            setmappedFilteredData([])
            setPagination([])
          }
        }
      })
      .catch(error => {
        setIsLoading(false)
        // console.log("Error", error);
      })
  }
  async function getStockOrderStatusTypes () {
    await ds
      .getStockOrderStatusTypes(BEHAVIOUR_TYPE.GET)
      .then(res => {
        // setLoader(false);
        if (res.data.data) {
          let mapped = res.data.data.map((data, i) => {
            return {
              key: i,
              statusName: data.displayName,
              statusID: getDecryptID(data.stockOrderStatusTypeID)
            }
          })
          setmappedStatusData(mapped)
        }
      })
      .catch(error => {
        setIsLoading(false)
        // console.log(error);
      })
  }
  async function getSuppliersService () {
    await ds
      .getSuppliers({ IsAll: true }, BEHAVIOUR_TYPE.GET)
      .then(res => {
        if (res.data.data && res.data.data.length > 0) {
          let data = res.data.data.map(e => {
            return {
              SupplierID: e.supplierID.toString(),
              SupplierName: e.supplierName
            }
          })
          setSupplierData(data)
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setIsLoading(false)
      })
  }
  //#endregion Api Services

  //#region Submission Function
  const onFinish = values => {
    if (values != null) {
      let body = {
        StockOrderStatusTypeID:
          values.StockStatusID != undefined ? values.StockStatusID : '',
        SupplierID: values.SupplierID != undefined ? values.SupplierID : '',
        OutletID: values.OutletID != undefined ? values.OutletID : '',
        CurrentPageNo: getPagination.current,
        pageSize: getPagination.pageSize
      }
      getStockOrderListingData(body, PkgFeatures.InventoryManagement)
    }
  }

  const onFinishFailed = errorInfo => {
    message.error('Kindly provide correct data')
  }
  const handleTableChange = (pagination, filters, sorter) => {
    let body = { CurrentPageNo: pagination.current }
    getStockOrderListingData(body, PkgFeatures.InventoryManagement)
  }

  //#endregion Submission Function

  const FormFields = () => {
    const children = []
    children.push(
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`StockStatusID`}
          label={<IntlMessages id='stock.list.show' />}
        >
          <Select size='middle' showSearch optionFilterProp='children'>
            {mappedStatusData &&
              mappedStatusData.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.statusID}>
                    {e.statusName}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={'OutletID'}
          label={<IntlMessages id='stock.list.selout' />}
        >
          <Select
            showSearch
            optionFilterProp='children'
            defaultValue={'All Outlets'}
          >
            <Select.Option key={'0'} value={'0'}>
              {'All Outlets'}
            </Select.Option>
            {getReduxStoreOutlets &&
              getReduxStoreOutlets.length > 0 &&
              getReduxStoreOutlets.map((e, key) => {
                return (
                  <Select.Option key={key} value={getDecryptID(e.id)}>
                    {e.outlet}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,

      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom ant-form-margin-top ant-form-custom-alignment'
          name={`SupplierID`}
          label={<IntlMessages id='stock.add.supp' />}
        >
          <Select size='middle' showSearch optionFilterProp='children'>
            {supplierData &&
              supplierData.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.SupplierID}>
                    {e.SupplierName}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,

      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`DeliveryDate`}
          label={'Delivery Due'}
        >
          <DatePicker
            size='middle'
            className='gx-mb-3 gx-w-100'
            inputReadOnly={true}
          />
        </Form.Item>
      </Col>,

      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom ant-form-margin-top ant-form-custom-alignment'
          name={`supplierName`}
          label={'Name/Number/Product/Supplier'}
        >
          <Input size='middle' placeholder='Supplier Invoice' />
        </Form.Item>
      </Col>
    )

    if (getExpand) {
      return children
    } else {
      return children.slice(0, 3)
    }
  }

  const columns = [
    {
      title: <IntlMessages id='stock.list.col1' />,
      dataIndex: 'number',
      key: 'number',
      render: (text, record) => (
        <div
          onClick={() =>
            history.push(
              `/Dashboard/inventory/stockcontrol/viewstock/${record.StockOrderID}`
            )
          }
          style={{ cursor: 'pointer', marginLeft: '10px' }}
        >
          <Row>
            <Col>
              <h5>
                <strong style={{ color: '#038fde' }}>{record.number}</strong>
              </h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <span
                style={{
                  textDecoration: 'underline'
                }}
                className='dk-font-10'
              >
                {record.StockOrderType}
              </span>
            </Col>
          </Row>
        </div>
      )
    },
    {
      title: <IntlMessages id='stock.list.col2' />,
      dataIndex: 'from',
      key: 'from',
      render: (text, record) => {
        return (
          <>
            <Row>
              <Col>
                <p className='dk-mg-bt-1'>{text}</p>
              </Col>
            </Row>
            {!StringIsNullOrEmpty(record.SupplierInvoiceNumber) ? (
              <Row>
                <Col>
                  <span className='dk-font-10'>
                    <IntlMessages id='stock.list.invoice' /> :
                    {' ' + record.SupplierInvoiceNumber}
                  </span>
                </Col>
              </Row>
            ) : (
              ''
            )}
          </>
        )
      }
    },
    {
      title: <IntlMessages id='stock.list.col3' />,
      dataIndex: 'to',
      key: 'to',
      render: (text, record) => {
        const rowDate = moment(record.DeliveryDate)
        const isPastDate = rowDate.isSameOrBefore(moment())
        return (
          <>
            <div
              className={`${
                (record.StockOrderStatusTypeID ==
                  StockOrderStatusTypesEnum.SentOrders ||
                  record.StockOrderStatusTypeID ==
                    StockOrderStatusTypesEnum.DispatchedOrders) &&
                isPastDate
                  ? 'dk-warning'
                  : ''
              }`}
            >
              <Row>
                <Col>
                  <p className='dk-mg-bt-1'>{text}</p>
                </Col>
              </Row>
              {/* record.StockOrderStatusTypeID != StockOrderStatusTypesEnum.ReceivedOrders */}
              {!StringIsNullOrEmpty(record.DeliveryDate) ? (
                <Row>
                  <Col>
                    <span className='dk-font-10'>
                      <IntlMessages id='stock.list.due' /> :
                      {' ' + moment(record.DeliveryDate).format('DD MMMM YYYY')}
                    </span>
                  </Col>
                </Row>
              ) : (
                ''
              )}
            </div>
          </>
        )
      }
    },
    {
      title: <IntlMessages id='stock.list.col4' />,
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        return <p>{text}</p>
      }
    },
    {
      title: <IntlMessages id='stock.list.col5' />,
      dataIndex: 'reference',
      key: 'reference',
      render: (text, record) => {
        return <p>{text}</p>
      }
    },
    {
      title: <IntlMessages id='stock.list.col6' />,
      dataIndex: 'created',
      key: 'created',
      render: (text, record) => {
        return <p>{moment(text).format('DD MMMM YYYY')}</p>
      }
    },
    {
      title: <IntlMessages id='stock.list.col7' />,
      dataIndex: 'items',
      key: 'items',
      render: (text, record) => {
        return <p>{text}</p>
      }
    },
    {
      title: <IntlMessages id='stock.list.col8' />,
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (text, record) => {
        let finalText = text
          ? formatDigits(text, getDefaultDecimalPlaces)
          : '0.00'
        return <p>{`${finalText}${getCurrSymbol}`}</p>
      }
    },
    {
      title: <IntlMessages id='products.promotionlisting.edit' />,
      dataIndex: 'edit',
      key: 'edit',
      render: (text, record) => {
        return getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <div>
            {record.StockOrderTypeID ==
              parseInt(StockOrderTypesEnum.OrderStock) &&
            record.StockOrderStatusTypeID !=
              StockOrderStatusTypesEnum.ReceivedOrders &&
            record.StockOrderStatusTypeID !=
              StockOrderStatusTypesEnum.CancelledOrders ? (
              <span>
                <a
                  onClick={() =>
                    history.push(
                      `/Dashboard/inventory/stockcontrol/edit/${record.StockOrderID}/false`
                    )
                  }
                  className='pen-edit'
                >
                  <i className='icon icon-edit' />
                </a>
              </span>
            ) : (
              ''
            )}
          </div>
        )
      }
    }
  ]

  return (
    <>
      {getIsAllowRead && isFeatureAllowed ? (
        <Spin
          tip={<IntlMessages id='sell.cashlisting.cashloading' />}
          spinning={getIsLoading}
          size='large'
        >
          <div className='Content-wrapper StockControl-pg'>
            <Row className='align-items-center justify-content-between mb-3 StockControl-header'>
              <Col lg={7} md={24} sm={24} xs={24}>
                <h1 className='d-flex align-items-center mb-0'>
                  <IntlMessages id='products.stockControl.stockControlTitle' />
                </h1>
              </Col>

              <Col lg={17} md={24} sm={24} xs={24} className='text-right'>
                <div className='pg-header-btn mt-10-md stockControll-btn'>
                  <Button
                    className=''
                    type='primary'
                    onClick={() => {
                      history.push('/Dashboard/inventory/stockcontrol/addstock')
                    }}
                    disabled={getIsDisableCreate}
                    size='large'
                  >
                    <IntlMessages id='products.stockControl.button1' />
                  </Button>
                  <Button
                    className=''
                    type='primary'
                    onClick={() => {
                      history.push(
                        '/Dashboard/inventory/stockcontrol/receivestock/receive'
                      )
                    }}
                    disabled={getIsDisableCreate}
                    size='large'
                  >
                    <IntlMessages id='products.stockControl.button2' />
                  </Button>
                  <Button
                    className=''
                    type='primary'
                    onClick={() => {
                      history.push(
                        '/Dashboard/inventory/stockcontrol/returnstock'
                      )
                    }}
                    disabled={getIsDisableCreate}
                    size='large'
                  >
                    <IntlMessages id='products.stockControl.button3' />
                  </Button>
                  <Button
                    className=''
                    type='primary'
                    onClick={() => {
                      history.push(
                        '/Dashboard/inventory/stockcontrol/transferstock'
                      )
                    }}
                    disabled={getIsDisableCreate}
                    size='large'
                  >
                    <IntlMessages id='products.stockControl.button4' />
                  </Button>
                </div>
              </Col>
            </Row>

            <Card className='gx-card' title=''>
              <Collapse>
                <Panel
                  className='custom-promolist-help'
                  showArrow={false}
                  header={<IntlMessages id='products.stockControl.helpTitle' />}
                >
                  <Row>
                    <div className='billing-main'>
                      <Col className='custom-promolist-helpdesc' md={12}>
                        <p>
                          <IntlMessages id='products.stockControl.helpDesc1' />
                        </p>
                        <p>
                          <IntlMessages id='products.stockControl.helpDesc2' />
                        </p>
                      </Col>

                      <Col md={12}>
                        <img src={StockControl} alt='' />
                      </Col>
                    </div>
                  </Row>
                </Panel>
              </Collapse>
            </Card>

            <Card className='gx-card Filters-wrapper No-BoxShadow'>
              <Form
                form={form}
                name='advanced_search'
                className='ant-advanced-search-form Filters-Form'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                  StockStatusID: '1'
                }}
              >
                <Row>{FormFields()}</Row>

                <Col span={24} lg={24} md={24} xs={24} sm={24}>
                  <div className='display-margin-unset StockControl-Form-btn'>
                    <Form.Item>
                      <Button
                        type='primary'
                        className='dk-btn-clear-field'
                        onClick={() => {
                          form.resetFields()
                          let body = {
                            StockOrderStatusTypeID: '',
                            SupplierID: '',
                            OutletID: '',
                            CurrentPageNo: getPagination.current,
                            pageSize: getPagination.pageSize
                          }
                          getStockOrderListingData(body, PkgFeatures.InventoryManagement)
                        }}
                      >
                        <IntlMessages id='sell.salehistory.clear' />
                      </Button>
                      <Button className='' type='primary' htmlType='submit'>
                        <IntlMessages id='sell.salehistory.search' />
                      </Button>
                    </Form.Item>
                  </div>
                </Col>
              </Form>
            </Card>

            <div className='tab-body-parent'>
              <Card className='gx-card No-BoxShadow'>
                {Loader ? (
                  <Skeleton count={7} height={35} />
                ) : (
                  <Table
                    className='gx-table-responsive'
                    columns={columns}
                    dataSource={mappedFilteredData}
                    pagination={getPagination}
                    onChange={handleTableChange}
                  />
                )}
              </Card>
            </div>
          </div>
        </Spin>
      ) : (
        <NotAllowedComponent
          getAccessLoading={getAccessLoading}
          textType={!isFeatureAllowed ? 2 : 1}
        />
      )}
    </>
  )
}
export default StockControlList
